import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Bed, UtensilsCrossed, ArrowRight } from 'lucide-react';

const LavanderiaPage = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero */}
      <section className="py-20 bg-gradient-to-br from-white via-primary-light/20 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="text-primary font-medium text-sm tracking-widest uppercase mb-4 block">
              Servizio Lavanderia
            </span>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-text-primary mb-6">
              Scegli il tuo <span className="text-primary">Servizio</span>
            </h1>
            <p className="text-xl text-text-secondary max-w-2xl mx-auto">
              Kilolava offre servizi di lavanderia professionali per biancheria da letto e tovagliato per ristoranti.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Choice Cards */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8">
            {/* Biancheria Card */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <Link
                to="/biancheria"
                className="group block relative overflow-hidden rounded-3xl h-[500px]"
                data-testid="lavanderia-biancheria-card"
              >
                {/* Background */}
                <div 
                  className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
                  style={{
                    backgroundImage: `url(https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=1200&q=80)`,
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-text-primary via-text-primary/50 to-transparent" />

                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-8">
                  <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    <Bed className="w-8 h-8 text-white" />
                  </div>
                  <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-3">
                    BIANCHERIA
                  </h2>
                  <p className="text-white/80 text-lg mb-4">
                    Per Case Vacanza, Affittacamere, Hotel e Case di Riposo
                  </p>
                  <div className="flex items-center gap-2 text-primary font-medium group-hover:gap-4 transition-all">
                    <span>Scopri il servizio</span>
                    <ArrowRight className="w-5 h-5" />
                  </div>
                </div>
              </Link>
            </motion.div>

            {/* Tovagliato Card */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              <Link
                to="/tovagliato"
                className="group block relative overflow-hidden rounded-3xl h-[500px]"
                data-testid="lavanderia-tovagliato-card"
              >
                {/* Background */}
                <div 
                  className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
                  style={{
                    backgroundImage: `url(https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1200&q=80)`,
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-text-primary via-text-primary/50 to-transparent" />

                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-8">
                  <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    <UtensilsCrossed className="w-8 h-8 text-white" />
                  </div>
                  <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-3">
                    TOVAGLIATO
                  </h2>
                  <p className="text-white/80 text-lg mb-4">
                    Per Ristoranti che vogliono alzare la percezione del locale
                  </p>
                  <div className="flex items-center gap-2 text-primary font-medium group-hover:gap-4 transition-all">
                    <span>Scopri il servizio</span>
                    <ArrowRight className="w-5 h-5" />
                  </div>
                </div>
              </Link>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LavanderiaPage;
